import * as React from "react";
import Container from "@mui/material/Container";

function NLQuery(mode) {
	const [q, setQ] = React.useState(
		"why did conversions change last week on paid search?"
	);
	const [k, setK] = React.useState(8);
	const [days, setDays] = React.useState(90);
	const [loading, setLoading] = React.useState(false);
	const [rows, setRows] = React.useState([]);
	const [error, setError] = React.useState(null);

	async function runSearch() {
		setLoading(true);
		setError(null);

		const r = await fetch("https://api.dat-vps.com/jason");
		console.log(await r.json());
		// try {
		// 	const res = await fetch("/api/search", {
		// 		method: "POST",
		// 		headers: { "content-type": "application/json" },
		// 		body: JSON.stringify({ q, k: Number(k), days: Number(days) })
		// 	});
		// 	const data = await res.json();
		// 	if (!res.ok || !data.ok) throw new Error(data.error || "Search failed");
		// 	setRows(data.rows);
		// } catch (e) {
		// 	setError(e.message);
		// 	setRows([]);
		// } finally {
		// 	setLoading(false);
		// }
	}

	React.useEffect(() => {
		runSearch();
	}, []);

	return (
		<Container maxWidth="xl">
			<div id="htmlPage">
				<h1>TCAA NLQuery</h1>
				<div style={{ display: "grid", gap: 8 }}>
					<label>
						Question
						<textarea
							value={q}
							onChange={(e) => setQ(e.target.value)}
							rows={3}
							style={{ width: "100%" }}
							placeholder="Ask about channels, conversions, trends…"
						/>
					</label>
					<div style={{ display: "flex", gap: 8 }}>
						<label>
							Top-K
							<input
								type="number"
								min={1}
								max={50}
								value={k}
								onChange={(e) => setK(e.target.value)}
							/>
						</label>
						<label>
							Days window
							<input
								type="number"
								min={1}
								max={365}
								value={days}
								onChange={(e) => setDays(e.target.value)}
							/>
						</label>
						<button onClick={runSearch} disabled={loading || !q.trim()}>
							{loading ? "Searching…" : "Search"}
						</button>
					</div>
				</div>

				{error && (
					<div style={{ color: "crimson", marginTop: 12 }}>{error}</div>
				)}

				<div style={{ display: "grid", gap: 12, marginTop: 16 }}>
					{rows.map((r, i) => (
						<article
							key={i}
							style={{ border: "1px solid #ddd", borderRadius: 8, padding: 12 }}
						>
							<div style={{ fontSize: 12, color: "#666" }}>
								{typeof r.as_of === "object" && r.as_of !== null
									? JSON.stringify(r.as_of)
									: r.as_of}
								{" • "}
								{typeof r.hostname === "object" && r.hostname !== null
									? JSON.stringify(r.hostname)
									: r.hostname ?? "—"}
								{" • "}
								{typeof r.entity === "object" && r.entity !== null
									? JSON.stringify(r.entity)
									: r.entity}
								{"/"}
								{typeof r.name === "object" && r.name !== null
									? JSON.stringify(r.name)
									: r.name}
								{" • "}
								{typeof r.source === "object" && r.source !== null
									? JSON.stringify(r.source)
									: r.source}
								{"/"}
								{typeof r.medium === "object" && r.medium !== null
									? JSON.stringify(r.medium)
									: r.medium}
								{" • score "}
								{typeof r.score === "object" && r.score !== null
									? JSON.stringify(r.score)
									: Number(r.score).toFixed(4)}
							</div>
							<p style={{ marginTop: 8, whiteSpace: "pre-wrap" }}>
								{typeof r.content === "object" && r.content !== null
									? JSON.stringify(r.content)
									: r.content}
							</p>
						</article>
					))}
					{!loading && rows.length === 0 && <div>No results.</div>}
				</div>
			</div>
		</Container>
	);
}

export default NLQuery;
